import { ReactElement, useState } from "react";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, makeStyles } from "@material-ui/core";
import { OrganizationMember } from "../../types/organization.type";

type Props = {
  member: OrganizationMember;
  onConfirm: () => void;
  trigger: (handleOpen: () => void) => ReactElement;
};

const useStyles = makeStyles({
  root: {
    '& > .MuiDialog-container': {
      '& > .MuiPaper-root': {
        minWidth: '300px',
      },
    },
  },
});

export default function RemoveMemberDialog({ member, onConfirm, trigger }: Props) {
  const classes = useStyles();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCancel = () => {
    handleClose();
  };

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <>
      {trigger(handleOpen)}
      <Dialog open={open} onClose={handleClose} className={classes.root}>
        <DialogContent>
          <DialogContentText>Êtes-vous sûre de vouloir supprimer le membre {member.firstname} {member.lastname} de l&apos;organisation ?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Annuler</Button>
          <Button onClick={handleConfirm} color="secondary" variant="contained">Supprimer</Button>
        </DialogActions>
      </Dialog>
    </>
  )
} 